import { Component, OnInit, Input, Renderer2, OnDestroy, OnChanges } from "@angular/core";

export enum SizeEnum {
    sm = "sm",
    md = "md",
    lg = "lg",
}

@Component({
    selector: "edp-rounded-progress",
    templateUrl: "./edp-rounded-progress.component.html",
    styleUrls: ["./edp-rounded-progress.component.scss"],
})
export class EdpRoundedProgressComponent implements OnInit, OnDestroy, OnChanges {
    @Input() public size: SizeEnum;
    @Input() public position: string;
    @Input() public percentage: number;

    public svg = null;
    public progress: number;

    constructor(private renderer: Renderer2) {}

    public ngOnInit() {
        if (this.position === "full") {
            this.renderer.addClass(document.body, "overflow-hidden");
        }
        this.render();
    }

    public ngOnChanges() {
        this.calcPercentage();
    }

    public calcPercentage() {
        this.progress = 500 - (172 * this.percentage) / 100;
    }

    public ngOnDestroy() {
        if (this.position === "full") {
            this.renderer.removeClass(document.body, "overflow-hidden");
        }
    }

    private render() {
        switch (this.size) {
            case SizeEnum.sm:
                this.svg = this.applySvg(40);
                break;
            case SizeEnum.md:
                this.svg = this.applySvg(60);
                break;
            default:
                this.svg = this.applySvg(80);
                break;
        }
    }

    private applySvg(boxSize: number = 80): object {
        const href = `${location.href}`;

        return {
            url: `url("${href}#linearGradient")`,
            viewBox: `0 0 ${boxSize} ${boxSize}`,
            width: boxSize,
            height: boxSize,
            circleFill: {
                strokeWidth: boxSize / 2 / 10,
                cx: boxSize / 2,
                cy: boxSize / 2,
                r: boxSize / 2 - boxSize / 2 / 10,
            },
            circleProgress: {
                strokeWidth: boxSize / 10 - 1,
                cx: boxSize / 2,
                cy: boxSize / 2,
                r: boxSize / 2 - boxSize / 2 / 10,
            },
        };
    }
}
